<div
  class="king-user-avatar"
  [class.size-1]="size() === 1"
  [class.size-2]="size() === 2"
  [class.has-user]="kingUser() !== null"
  [class.hit]="isHit()"
  [style.cursor]="kingUser() === null ? 'default' : 'pointer'"
  (click)="
    kingUser() ? contextMenuService.open($event, { user: kingUser()! }) : null
  "
  #hpBarWrapper
>
  <!-- Hit indicators (left for challenger, right for king) -->
  @if (kingUser() && size() === 1) {
    <div class="hit-indicators" aria-live="polite" aria-atomic="false">
      @if (showCritical()) {
        <div class="hit-indicator critical-hit" role="status">
          <span class="critical-text">CRITICAL HIT</span>
          <span class="damage-value">{{ criticalDamage() | number:'1.0-0' }}</span>
        </div>
      }
      @if (showMiss()) {
        <div class="hit-indicator miss-hit" role="status">
          <span class="miss-text">MISS</span>
        </div>
      }
      @if (showDamage()) {
        <div class="hit-indicator damage-hit" role="status">
          <img
            class="hit-marker-icon"
            src="assets/icons/king-new/hit-marker.svg"
            alt="hit marker"
          />
          <span class="damage-value">-{{ lastDamage() | number:'1.0-0' }}</span>
        </div>
      }
    </div>
  }

  <!-- HP Bar Circle -->
  @if (kingUser()) {
    <svg
      animate.enter="fade-in"
      class="king-user-avatar__hp-circle"
      [attr.viewBox]="svgViewBox()"
      role="img"
      [attr.aria-label]="'Health: ' + hpPercent() + ' percent'"
    >
      <!-- Background circle -->
      <circle
        class="hp-circle-bg"
        [attr.cx]="circleCenter()"
        [attr.cy]="circleCenter()"
        [attr.r]="circleRadius()"
        fill="none"
        [attr.stroke-width]="circleStrokeWidth()"
      />
      <!-- HP circle -->
      <circle
        class="hp-circle-fill"
        [attr.cx]="circleCenter()"
        [attr.cy]="circleCenter()"
        [attr.r]="circleRadius()"
        fill="none"
        [attr.stroke-width]="circleStrokeWidth()"
        [attr.stroke-dasharray]="circleCircumference()"
        [attr.stroke-dashoffset]="strokeDashoffset()"
      />
      <!-- Damage arc (shows damage on top of HP) -->
      @if (damageArcPercent() > 0) {
        <circle
          animate.enter="fade-in"
          class="hp-circle-damage"
          [attr.cx]="circleCenter()"
          [attr.cy]="circleCenter()"
          [attr.r]="circleRadius()"
          fill="none"
          [attr.stroke-width]="circleStrokeWidth()"
          [attr.stroke-dasharray]="damageArcDasharray()"
          [attr.stroke-dashoffset]="damageArcDashoffset()"
        />
      }
    </svg>
  }
  <img
    class="king-user-avatar__avatar"
    [src]="kingUser()?.avatar ?? fallbackAvatar()"
    [alt]="kingUser()?.name ?? (isChallenger() ? 'Challenger placeholder' : 'King placeholder')"
    [class.placeholder]="kingUser() === null"
  />
  @if (isWinner()) {
    <img
      animate.enter="fade-in"
      class="king-user-avatar__crown"
      src="assets/images/king/crown.png"
      alt="winner"
    />
  }
</div>

<!-- HP Text below avatar -->
@if (kingUser() && size() === 1) {
  <div animate.enter="fade-in" class="hp-text" role="status" [attr.aria-label]="'HP: ' + (displayHp() | number:'1.0-0') + ' of ' + (kingUser()!.initial_hp | number:'1.0-0')">
    <span class="hp-current">{{ displayHp() | number:'1.0-0' }}</span>
    <span class="hp-separator">/ {{ kingUser()!.initial_hp | number:'1.0-0' }} HP</span>
  </div>
} @else {
    <div class="empty-hp"></div>
}
